
import L from 'leaflet';
import 'leaflet-draw/dist/leaflet.draw.css';
import 'leaflet-draw';

import './plugins/leaflet-measure-path/leaflet-measure-path.css';
import './plugins/leaflet-measure-path/leaflet-measure-path.js';


import { areaMeasure } from './plugins/areaMeasure.js';
import { distanceMeasure } from './plugins/distanceMeasure.js';
import markerIcon from '@/assets/images/icon/marker-icon.png';
import markerShadow from '@/assets/images/icon/marker-shadow.png';

export class MapUtils {

    static createLayer() {
        let leafletLayer = L.featureGroup();
        return leafletLayer;
    }




    static createDrawControl(layer) {


        const customIcon = L.AwesomeMarkers.icon({

            markerColor: 'red',
            popupAnchor: [0, -66], // 弹出窗口锚点
        });
        // 定义自定义图标和阴影图标
        // const customIcon = L.icon({
        //     iconUrl: markerIcon, // 替换为你的图标路径
        //     iconSize: [25, 41], // 图标大小
        //     iconAnchor: [12.5, 41], // 图标锚点
        //     popupAnchor: [-3, -76], // 弹出窗口锚点
        //     shadowUrl: markerShadow, // 替换为你的阴影图标路径
        //     shadowSize: [41, 41], // 阴影图标大小
        //     shadowAnchor: [12.5, 41] // 阴影图标锚点
        // });

        return new L.Control.Draw({
            position: 'topright',//控件位置 'topleft'(默认), 'topright', 'bottomleft' or 'bottomright'
            draw: {
                polyline: true,
                polygon: true,
                rectangle: true,
                circle: true,
                marker: {
                    icon: customIcon,
                },
                circlemarker: true,
            },
            edit: {
                featureGroup: layer,
                edit: true,
                remove: true,
            }
        });
    }
    static createMarkerPopup(options) {
        // 创建属性填写表单
        const form = document.createElement('form');
        form.innerHTML = options.html || `
            <label for="name">名称:</label>
            <input type="text" id="name" name="name"><br>
            <label for="description">描述:</label>
            <textarea id="description" name="description"></textarea><br>
            <input type="submit" value="保存">
        `;

        // 绑定弹窗到图层
        const popup = L.popup()
            .setContent(form);
        return popup; // 返回弹出框实例
    }


    static createAreaMeasure(options) {
        return new areaMeasure(options);
    }
    static createDistanceMeasure(options) {
        return new distanceMeasure(options);
    }

    static defineCrs() {
        var crs = new L.Proj.CRS('EPSG:3395',
            '+proj=merc +lon_0=0 +k=1 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs',
            {
                resolutions: function () {
                    let level = 19
                    var res = [];
                    res[0] = Math.pow(2, 18);
                    for (var i = 1; i < level; i++) {
                        res[i] = Math.pow(2, (18 - i))
                    }
                    return res;
                }(),
                origin: [0, 0],
                bounds: L.bounds([20037508.342789244, 0], [0, 20037508.342789244])
            });
        return crs;
    }
    static createBaiduLayer() {
        let layer = new L.TileLayer('https://maponline{s}.bdimg.com/tile/?qt=vtile&x={x}&y={y}&z={z}&udt=20160928&scale=1', {
            maxZoom: 18,
            minZoom: 3,
            subdomains: [0, 1, 2],
            tms: true
        });
        return layer;
    }
    static overwriteLeafletDraw() {
        L.drawLocal = {
            draw: {
                toolbar: {
                    actions: {
                        title: '取消绘制',
                        text: '取消'
                    },
                    finish: {
                        title: '完成绘制',
                        text: '完成'
                    },
                    undo: {
                        title: '删除最后绘制的点',
                        text: '删除最后一点'
                    },
                    buttons: {
                        polyline: '绘制折线',
                        polygon: '绘制多边形',
                        rectangle: '绘制矩形',
                        circle: '绘制圆形',
                        marker: '绘制标记点',
                        circlemarker: '绘制圆形标记'
                    }
                },
                handlers: {
                    circle: {
                        tooltip: {
                            start: '点击并拖动绘制圆形'
                        },
                        radius: '半径'
                    },
                    circlemarker: {
                        tooltip: {
                            start: '点击地图放置圆形标记'
                        }
                    },
                    marker: {
                        tooltip: {
                            start: '点击地图放置标记点'
                        }
                    },
                    polygon: {
                        tooltip: {
                            start: '点击开始绘制形状',
                            cont: '点击继续绘制形状',
                            end: '点击起点闭合图形'
                        }
                    },
                    polyline: {
                        error: '<strong>错误：</strong>图形边缘不能交叉！',
                        tooltip: {
                            start: '点击开始绘制线条',
                            cont: '点击继续绘制线条',
                            end: '点击终点完成线条'
                        }
                    },
                    rectangle: {
                        tooltip: {
                            start: '点击并拖动绘制矩形'
                        }
                    },
                    simpleshape: {
                        tooltip: {
                            end: '释放鼠标完成绘制'
                        }
                    }
                }
            },
            edit: {
                toolbar: {
                    actions: {
                        save: {
                            title: '保存修改',
                            text: '保存'
                        },
                        cancel: {
                            title: '取消编辑，放弃所有更改',
                            text: '取消'
                        },
                        clearAll: {
                            title: '清除所有图层',
                            text: '全部清除'
                        }
                    },
                    buttons: {
                        edit: '编辑图层',
                        editDisabled: '没有可编辑的图层',
                        remove: '删除图层',
                        removeDisabled: '没有可删除的图层'
                    }
                },
                handlers: {
                    edit: {
                        tooltip: {
                            text: '拖动手柄或标记点编辑要素',
                            subtext: '点击取消按钮撤销更改'
                        }
                    },
                    remove: {
                        tooltip: {
                            text: '点击要素进行删除'
                        }
                    }
                }
            }
        };
    }
    static overwriteLeaflet() {
        // 添加 Tooltip 的扩展方法
        // L.Tooltip.include({
        //   _animateZoom(e: any) {
        //     console.log("Tooltip", this, this._map);
        //     if (this._map) {
        //       console.log("添加 Tooltip 的扩展方法 :>> ", this._map);
        //       const pos = this._map._latLngToNewLayerPoint(
        //         this._latlng,
        //         e.zoom,
        //         e.center
        //       );
        //       this._setPosition(pos);
        //     } else {
        //       return;
        //     }
        //   },
        // });
        L.Tooltip.prototype._animateZoom = function (e) {
            if (!this._map) {
                return;
            }
            let pos = this._map._latLngToNewLayerPoint(
                this._latlng,
                e.zoom,
                e.center
            );
            this._setPosition(pos);
        };

        L.Tooltip.prototype._updatePosition = function () {
            if (!this._map) {
                return;
            }
            let pos = this._map.latLngToLayerPoint(this._latlng);
            this._setPosition(pos);
        };

        // 添加 Popup 的扩展方法
        L.Popup.include({
            _animateZoom(e) {
                if (this._map) {
                    const pos = this._map._latLngToNewLayerPoint(
                        this._latlng,
                        e.zoom,
                        e.center
                    );
                    const anchor = this._getAnchor();
                    L.DomUtil.setPosition(this._container, pos.add(anchor));
                } else {
                    return;
                }
            },
        });
        // 添加 Marker 的扩展方法
        L.Marker.include({
            _animateZoom(opt) {
                if (this._map) {
                    const pos = this._map
                        ._latLngToNewLayerPoint(this._latlng, opt.zoom, opt.center)
                        .round();
                    this._setPos(pos);
                }
            },
        });
    }
}